import Navigation from '@/components/landing/Navigation';
import HeroSection from '@/components/landing/HeroSection';
import CategoryReframe from '@/components/landing/CategoryReframe';
import CapabilityGrid from '@/components/landing/CapabilityGrid';
import AgentsInPractice from '@/components/landing/AgentsInPractice';
import HowItWorks from '@/components/landing/HowItWorks';
import WhyItMatters from '@/components/landing/WhyItMatters';
import Industries from '@/components/landing/Industries';
import SecurityTrust from '@/components/landing/SecurityTrust';
import ComplianceBadges from '@/components/landing/ComplianceBadges';
import GlobalPresence from '@/components/landing/GlobalPresence';
import AurocleDifference from '@/components/landing/AurocleDifference';
import CommandCenter from '@/components/landing/CommandCenter';
import ForecastSection from '@/components/landing/ForecastSection';
import QuantumReady from '@/components/landing/QuantumReady';
import ROICalculator from '@/components/landing/ROICalculator';
import MultiLayerExplainer from '@/components/landing/MultiLayerExplainer';
import WhitepaperGate from '@/components/landing/WhitepaperGate';
import BookingContact from '@/components/landing/BookingContact';
import Pricing from '@/components/landing/Pricing';
import FAQ from '@/components/landing/FAQ';
import FinalCTA from '@/components/landing/FinalCTA';
import Footer from '@/components/landing/Footer';
import LiveActivityTicker from '@/components/landing/LiveActivityTicker';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-aurocle-base text-aurocle-text font-body" data-testid="landing-page">
      <div className="noise-overlay" aria-hidden="true" />
      <Navigation />
      <HeroSection />
      <CategoryReframe />
      <CapabilityGrid />
      <AgentsInPractice />
      <HowItWorks />
      <CommandCenter />
      <WhyItMatters />
      <Industries />
      <SecurityTrust />
      <ComplianceBadges />
      <GlobalPresence />
      <AurocleDifference />
      <ForecastSection />
      <QuantumReady />
      <ROICalculator />
      <MultiLayerExplainer />
      <WhitepaperGate />
      <BookingContact />
      <Pricing />
      <FAQ />
      <FinalCTA />
      <Footer />
      <LiveActivityTicker />
    </div>
  );
}
